// extracted by mini-css-extract-plugin
export default {"modal":"ModalLayout_modal__5eJzP","close":"ModalLayout_close__98go7","overlay":"ModalLayout_overlay__lsEbB"};